export const SNOOZE_OPTIONS: SnoozeOption[] = [
    {
        key: 'SNOOZE_AT_EVENT_HOUR',
        duration: null,
        type: null,
        negativeDuration: null
    },
    {
        key: 'SNOOZE_1_MINUTE_BEFORE',
        duration: 1,
        type: 'minutes',
        negativeDuration: 1
    },
    /*{
        key: 'SNOOZE_5_MINUTE_BEFORE',   Zimbra always show reminders as 5 min so these options not necessary for now.
        duration: 5,
        type: 'minutes',
        negativeDuration: 1
    },
    {
        key: 'SNOOZE_15_MINUTE_BEFORE',
        duration: 15,
        type: 'minutes',
        negativeDuration: 1
    },
    {
        key: 'SNOOZE_30_MINUTE_BEFORE',
        duration: 30,
        type: 'minutes',
        negativeDuration: 1
    },
    {
        key: 'SNOOZE_1_HOUR_BEFORE',
        duration: 1,
        type: 'hours',
        negativeDuration: 1
    },
    {
        key: 'SNOOZE_2_HOUR_BEFORE',
        duration: 2,
        type: 'hours',
        negativeDuration: 1
    },
    {
        key: 'SNOOZE_12_HOUR_BEFORE',
        duration: 12,
        type: 'hours',
        negativeDuration: 1
    },
    {
        key: 'SNOOZE_1_DAY_BEFORE',
        duration: 1,
        type: 'days',
        negativeDuration: 1
    },*/
    {
        key: 'SNOOZE_1_MINUTE',
        duration: 1,
        type: 'minutes',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_5_MINUTE',
        duration: 5,
        type: 'minutes',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_10_MINUTE',
        duration: 10,
        type: 'minutes',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_15_MINUTE',
        duration: 15,
        type: 'minutes',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_30_MINUTE',
        duration: 30,
        type: 'minutes',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_45_MINUTE',
        duration: 45,
        type: 'minutes',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_1_HOUR',
        duration: 1,
        type: 'hours',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_2_HOUR',
        duration: 2,
        type: 'hours',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_4_HOUR',
        duration: 4,
        type: 'hours',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_8_HOUR',
        duration: 8,
        type: 'hours',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_1_DAY',
        duration: 1,
        type: 'days',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_2_DAY',
        duration: 2,
        type: 'days',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_3_DAY',
        duration: 3,
        type: 'days',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_4_DAY',
        duration: 4,
        type: 'days',
        negativeDuration: 0
    },
    {
        key: 'SNOOZE_1_WEEK',
        duration: 1,
        type: 'weeks',
        negativeDuration: 0
    },
];

class SnoozeOption {
    key: string;
    duration: number;
    type: any; // has to be any type because moment.js gives error
    negativeDuration: number;
}
